"use client";
import React from "react";
import { Popover, PopoverProps } from "@mui/material";

export type WcPopoverProps = PopoverProps;

export const WcPopover = ({ children, ...props }: WcPopoverProps) => <Popover {...props}>{children}</Popover>;

export default WcPopover;

// import { Popover, PopoverProps } from "@mui/material";

// export const WcPopover = Popover;
// export type WcPopoverProps = PopoverProps;

// export default WcPopover;
